import gsap from "gsap";

// Все подписанные элкмкнты доступны
window.addEventListener('load', function () {
    document.querySelectorAll('.js-loader-action').forEach((elem) => {
        elem.style.display = 'block';

        let gsap_action_from = elem.getAttribute('data-load-gsap-from');
        let gsap_action_to = elem.getAttribute('data-load-gsap-to');

        let gsap_action_preset = elem.getAttribute('data-load-gsap-preset');

        switch (gsap_action_preset) {
            case "opacity":
                gsap_action_from    = '{"opacity":0}';
                gsap_action_to      = '{"opacity":1}';
                break;

            case "openimage":
                gsap_action_from    = '{"top":"0%"}';
                gsap_action_to      = '{"top":"100%"}';
                break;

            case "openimage2":
                gsap_action_from    = '{"top":"0%"}';
                gsap_action_to      = '{"top":"100%", "delay": 0.2}';
                break;

            default:
                break;
        }


        if (gsap_action_from && gsap_action_to) {
            gsap.fromTo(elem, JSON.parse(gsap_action_from), JSON.parse(gsap_action_to));
        } else {
            if (gsap_action_to) {
                gsap.to(elem, JSON.parse(gsap_action_to));
            }
        }
    });
});